export const STAT_INCREMENT = "STAT_INCREMENT";
export const STAT_DECREMENT = "STAT_DECREMENT";